<template>
    <v-dialog width="350px" v-model="viewMenu">
        <v-card>
            <v-card-title>neuer Durchlaufträger</v-card-title>
            <v-card-text>
                <v-data-table
                    dense
                    hide-default-footer
                    :headers="headers"
                    :items="items"
                    items-per-page="100"
                    >
                    <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Anzahl der Felder: {{items.length}}</v-toolbar-title>
                        <v-btn icon color="green" @click="items.push({länge:1})"><v-icon>add_box</v-icon></v-btn>
                    </v-toolbar>
                    </template>

                    <template v-slot:item="props">
                        <tr>
                            <td class="text-left">Feld Nr.{{items.indexOf(props.item)+1}}</td>
                            <td class="text-right"><input style="text-align:right; width: 50px" type="number" min="0.01" step="0.01" v-model.number="props.item.länge"></td>
                            <td class="text-right pr-0"><v-icon color="red" small @click="deleteItem(props.item)">clear</v-icon></td>
                        </tr>
                    
                    </template>

                    <template v-slot:body.prepend>
                        <tr>
                            <td class="text-left">Kragarm links</td>
                            <td class="text-right"><input v-if="kragarmLinks.enabled" style="text-align:right; width: 50px" type="number" min="0.01" step="0.01" v-model.number="kragarmLinks.länge"></td>
                            <td class="text-right pr-0">
                                <v-icon v-if="!kragarmLinks.enabled" color="green" small @click="kragarmLinks.enabled = !kragarmLinks.enabled">add_box</v-icon>
                                <v-icon v-else color="red" small @click="kragarmLinks.enabled = !kragarmLinks.enabled">clear</v-icon>
                            </td>
                        </tr>
                    </template>

                    <template v-slot:body.append>
                        <tr>
                            <td class="text-left">Kragarm rechts</td>
                            <td class="text-right"><input v-if="kragarmRechts.enabled" style="text-align:right; width: 50px" type="number" min="0.01" step="0.01" v-model.number="kragarmRechts.länge"></td>
                            <td class="text-right pr-0">
                                <v-icon v-if="!kragarmRechts.enabled" color="green" small @click="kragarmRechts.enabled = !kragarmRechts.enabled">add_box</v-icon>
                                <v-icon v-else color="red" small @click="kragarmRechts.enabled = !kragarmRechts.enabled">clear</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-btn small @click="apply()" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" >Abbrechen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data(){
        return{
            headers: [
                { text: 'Feld', align: 'left', sortable: false, value: 'Feld'},
                { text: 'Länge',width: '50px', align: 'left', sortable: false, value: 'länge' },
                { text: '', width: '20px', align: 'right', sortable: false, value: 'action' }
             ],
            kragarmLinks: {enabled: false, länge: 1},
            kragarmRechts: {enabled: false, länge: 1},
            items: [{länge: 2.50},{länge: 2.50}]
        }
    },
    computed: {
        viewMenu: {
            get() { return this.$store.getters.vNewDLTMenu },   
            set(value) { this.$store.commit('setvNewDLTMenu', value)} 
        },
    },
    methods: {
        deleteItem(item){
            this.items.splice(this.items.indexOf(item),1)
        },
        apply(){
            let SystemData = { 
                kragarmLinks: {enabled: this.kragarmLinks.enabled, länge: this.kragarmLinks.länge},
                kragarmRechts: {enabled: this.kragarmRechts.enabled, länge: this.kragarmRechts.länge},
                Felder: this.items //.map(item => { return {länge: item.länge } })
                }
            this.$store.dispatch('newDLT', SystemData)
            this.viewMenu = false
        },
        cancel(){
            this.viewMenu = false
        },
    },
}
</script>